import { Card } from "primereact/card";
import { CompanyDetails } from "./CompanyDetails";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Fetch } from "../../../../shared/Fetch";
import { POCDetails } from "./POCDetails";
import { AccountDetails } from "./AccountDetails";
import { SignatoryDetails } from "./SignatoryDetails";
// import { SubVendorCompanyDetails } from "./subvendorForm/SubVendorCompanyDetails";
import { SubCendorPOCDetails } from "./subvendorForm/SubCendorPOCDetails";
import { SubVendorAccountDetails } from "./subvendorForm/SubVendorAccountDetails";
import { SubVendorSignatoryDetails } from "./subvendorForm/SubVendorSignatoryDetails";
import { SubVendorCompanyDetails } from "./subvendorForm/SubVendorCompanyDetails";
import { ILogin } from "../../../../models/Login";

export const SubVendorDetails = () => {
    const [modelA, setModelA] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [modelB, setModelB] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [modelC, setModelC] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [modelD, setModelD] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [modelsData, setModelsData] = useState();
    const [reload1, setReload] = useState(false);
    const getSubvendorDetails = async () => {
        const response = await Fetch("ResourceVendor_Company_Mast", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setModelsData(data);
        }
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const reload = () => { }
    const toast = useRef<any>(null);


    useEffect(() => {
        getSubvendorDetails();
    }, []);
    const hideDialog = () => {
        setModelA(prev => prev = { singleData: {}, open: false })
        setModelB(prev => prev = { singleData: {}, open: false })
        setModelC(prev => prev = { singleData: {}, open: false })
        setModelD(prev => prev = { singleData: {}, open: false })

        setReload(!reload1);
    };
    useEffect(() => {
        getSubvendorDetails();
    }, [reload1]);

    return (
        <>
            <Card title="Dashboard" className="consultant-dashboard-card">
                <div className="p-fluid formgrid grid mt-3">
                    <div className="field col-12 md:col-6">
                        <CompanyDetails modelData={modelsData} open={modelA.open} singleData={modelA.singleData} setModel={setModelA} reload={reload} />
                    </div>
                    {loginObj.user_Type === 3 && <div className="field col-12 md:col-6">
                        <POCDetails modelData={modelsData} open={modelB.open} singleData={modelB.singleData} setModel={setModelB} reload={reload} />
                    </div>}
                    <div className="field col-12 md:col-6">
                        <AccountDetails modelData={modelsData} open={modelC.open} singleData={modelC.singleData} setModel={setModelC} reload={reload} />
                    </div>
                    {/* {<div className="field col-12 md:col-6">
                        <SignatoryDetails modelData={modelsData} reload1={reload1} open={modelD.open} singleData={modelD.singleData} setModel={setModelD} reload={reload} />
                    </div>} */}
                </div>
                {modelA.open && <Dialog visible={modelA.open} style={{ width: "65vw" }} header="Company Details" modal className="p-fluid" onHide={() => setModelA(prev => prev = { singleData: {}, open: false })}>
                    <SubVendorCompanyDetails hideDialog={hideDialog} toast={toast} reload1={reload1} setReload={setReload} reload={reload} open={modelA.open} singleData={modelA.singleData} />
                </Dialog>}
                {modelB.open && <Dialog visible={modelB.open} style={{ width: "65vw" }} header="POC Details" modal className="p-fluid" onHide={() => setModelB(prev => prev = { singleData: {}, open: false })}>
                    <SubCendorPOCDetails hideDialog={hideDialog} toast={toast} reload1={reload1} setReload={setReload} open={modelB.open} singleData={modelB.singleData} />
                </Dialog>}
                {modelC.open && <Dialog visible={modelC.open} style={{ width: "65vw" }} header="Account Person Details" modal className="p-fluid" onHide={() => setModelC(prev => prev = { singleData: {}, open: false })}>
                    <SubVendorAccountDetails hideDialog={hideDialog} toast={toast} reload1={reload1} setReload={setReload} open={modelC.open} singleData={modelC.singleData} />
                </Dialog>}
                {/* {modelD.open && <Dialog visible={modelD.open} style={{ width: "65vw" }} header="Signatory Details" modal className="p-fluid" onHide={() => setModelD(prev => prev = { singleData: {}, open: false })}>
                    <SubVendorSignatoryDetails hideDialog={hideDialog} toast={toast} reload1={reload1} setReload={setReload} open={modelD.open} singleData={modelD.singleData} />
                </Dialog>} */}
            </Card>
            <div style={{ marginTop: "2rem" }}></div>
            <Toast ref={toast} />
        </>
    );
}